import { AddOutlined, EditOutlined, RefreshOutlined } from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import SearchIcon from "@mui/icons-material/Search";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { AMIService } from "../../../../service/AMI/AMIService";
import AMIDialogForm from "./AMIDialogForm";

const AssociationsAMIList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const [offres, setOffres] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const { Toast, showToast } = useToast();
  const [amiFormOpen, setAmiFormOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idAmi, setIdAmi] = useState(null);
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleShowCandidatList = (id) => {
    navigate(`formulaire?ref=${id}`);
  };
  const handleFetchVolontariatOffreList = () => {
    setDataLoading(true);
    AMIService.list({})
      .then((res) => {
        if (res && res.data) {
          setOffres(res.data);
          setFilteredRows(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleOpenOpenAmiForm = (idAmi) => {
    setIdAmi(idAmi);
    setAmiFormOpen(true);
  };

  const handleCloseAmiForm = () => {
    setAmiFormOpen(false);
    handleFetchVolontariatOffreList();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(offres);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      offres.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const table_colonne = [
    {
      field: "description",
      headerName: "Réference",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "libelle_type",
      headerName: "Titre",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "date_debut_publication",
      headerName: "Date de création",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "date_fin_publication",
      headerName: "Date de cloture",
      flex: 0.5,
      minWidth: 150,
    },
   /*  {
      field: "type",
      headerName: "Type de l'offre",
      flex: 0.5,
      minWidth: 150,
    }, */
    {
      field: "desc",
      headerName: "Catégorie",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "cloture",
      headerName: "Cloturé",
      flex: 0.8,
      minWidth: 120,
      renderCell: (params) => {
        return params.row.cloture === "1" ? "Oui" : "Non";
      },
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Parametrer AMI"
              color="primary"
              onClick={(e) => handleShowCandidatList(params.row.id_type)}
            >
              <SettingsOutlinedIcon />
            </IconButton>
            <IconButton
              title="Modifier AMI"
              color="secondary"
              onClick={(e) => handleOpenOpenAmiForm(params.row.id_type)}
            >
              <EditOutlined />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchVolontariatOffreList();
  }, []);

  return (
    <>
      <AMIDialogForm
        open={amiFormOpen}
        onFormClose={() => handleCloseAmiForm()}
        idAmi={idAmi}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="AMI"
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      placeholder="Recherche"
                      onChange={(e) => handleFilter(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchVolontariatOffreList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      onClick={(e) => handleOpenOpenAmiForm(null)}
                      title="Creer une offre"
                    >
                      <AddOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={offres}
                rows={filteredRows}
                getRowId={(row) => row.id_type}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AssociationsAMIList;
